import { IEnvConfig } from "../types";

const config: IEnvConfig = {
    app: {
        name: "",
        version: ""
    },
    api: {
        default: {
            url: "",
            rootPath: ""
        }
    },
    websocket: {
        url: "",
        isEnable: true
    },
    chat: {
        url: "",
        domain: "",
        isEnable: true
    }
};

export default config;
